export default "__VITE_ASSET__DRlI6Ndf__"